import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * [FROST BUDDY] Keeps the PDP price badges (sold out / coming soon / pre-order /
 * almost gone / sale) in sync with the selected variant.
 *
 * Upstream product-price.js only swaps its [ref="priceContainer"] on variant change,
 * so badges rendered by snippets/product-badges.liquid stayed stuck on the variant
 * the page was loaded with. This mirrors product-price's handler: when the variant
 * picker's ProductSelectEvent resolves, copy the matching badges out of the freshly
 * rendered section HTML.
 */
class FbPriceBadges extends Component {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#onProductSelect);
    this.#section = null;
  }

  /** @param {any} event */
  #onProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const next = html.querySelector(`fb-price-badges[data-block-id="${this.dataset.blockId}"]`);
        if (!next) return;

        this.innerHTML = next.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[fb-price-badges] product select promise rejected:', error);
      });
  };
}

if (!customElements.get('fb-price-badges')) {
  customElements.define('fb-price-badges', FbPriceBadges);
}
